// Types
import type { Action } from "./types";

/**
 * The bank refuses a claim payment when the bank account of the member is
 * wrong. An operator corrects the account and asks to send the payment again.
 * A second operator must approve that request before any money moves, so the
 * screens below always deal with two different people.
 */

/**
 * Loads the request that still waits for a decision on one claim.
 *
 * @param {string} claimGuid
 * @return {*} {Action}
 */
export const fetchClaimPaymentRetry = (claimGuid: string): Action => ({
  type: "FETCH_CLAIM_PAYMENT_RETRY",
  data: claimGuid,
});

/**
 * Loads the requests that wait for an approver.
 *
 * @return {*} {Action}
 */
export const fetchClaimPaymentRetryQueue = (): Action => ({
  type: "FETCH_CLAIM_PAYMENT_RETRY_QUEUE",
});

/**
 * Records the answer of the service in the store.
 *
 * @param {*} data
 * @return {*} {Action}
 */
export const setClaimPaymentRetry = (data: any): Action => ({
  type: "SET_CLAIM_PAYMENT_RETRY",
  data,
});

/**
 * @param {*} data
 * @return {*} {Action}
 */
export const setClaimPaymentRetryQueue = (data: any): Action => ({
  type: "SET_CLAIM_PAYMENT_RETRY_QUEUE",
  data,
});

/**
 * Asks to send a claim payment again. The request alone moves no money.
 *
 * @param {*} data
 * @return {*} {Action}
 */
export const requestClaimPaymentRetry = (data: any): Action => ({
  type: "REQUEST_CLAIM_PAYMENT_RETRY",
  data,
});

/**
 * Approves or refuses a request. The service refuses an approval by the
 * operator that asked, so this always runs as a second person.
 *
 * @param {*} data
 * @return {*} {Action}
 */
export const reviewClaimPaymentRetry = (data: any): Action => ({
  type: "REVIEW_CLAIM_PAYMENT_RETRY",
  data,
});

/**
 * @return {*} {Action}
 */
export const clearClaimPaymentRetry = (): Action => ({
  type: "CLEAR_CLAIM_PAYMENT_RETRY",
});
